import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../../../../../shared/services/auth.service';
import { Router } from '@angular/router';
import { UserInfo } from '../../../../../../../shared/models/user-info';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss'
})
export class AccountComponent {
  userInfo: UserInfo | null = null;
  isLogin: boolean = false;
  isAdmin: Boolean = false;

  constructor(private translate: TranslateService, private authService: AuthService, private router: Router) { 
    translate.setDefaultLang('fr');
  }

  ngOnInit(): void {
    
    this.authService.getUserInfo().subscribe(userInfo => {
      this.userInfo = userInfo;
      this.isLogin = !!userInfo; 
      this.isAdmin = this.authService.isAdmin();
    });
  }

  switchLanguage(language: string) {
    this.translate.use(language);
  }

  loginUser() {
    this.authService.login();
  }

  logout(){
    this.authService.logout();
  }

  editPassword(){
    this.authService.changePassword()
  }
}
